<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <div class="flex-between">
          <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="拼团状态：" prop="orderStatus">
              <el-select v-model="searchForm.orderStatus" placeholder="请选择" class="mt-search-width">
                <el-option
                  v-for="item in orderStatusArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="商品搜索：" prop="name">
              <el-input v-model="searchForm.name" placeholder="请输入拼团商品" class="mt-search-width"></el-input>
            </el-form-item>
            <el-form-item label="结束时间：" prop="date">
              <el-date-picker
                v-model="searchForm.date"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
              <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="headPicture"
            label="团长头像">
            <template slot-scope="scope">
              <el-image
                style="width: 40px;"
                :src="scope.row.headPicture == null ? imgServer+'no_img.png' : scope.row.headPicture"
                :preview-src-list="[scope.row.headPicture]"
                fit="contain"></el-image>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="nickName"
            label="团长昵称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="phone"
            label="团长手机号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="startTime"
            label="开团时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="goodsName"
            label="拼团商品">
          </el-table-column>
          <el-table-column
            align="center"
            prop="pinTuanPeopleNum"
            label="成团人数">
          </el-table-column>
          <el-table-column
            align="center"
            prop="participantNum"
            label="参与人数">
          </el-table-column>
          <el-table-column
            align="center"
            prop="orderStatus"
            label="状态">
            <template slot-scope="scope">
              <span>{{scope.row.orderStatus == 1 ? '拼团成功' : scope.row.orderStatus == 2 ? '拼团失败' : '拼团进行中'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="endTime"
            label="结束时间">
          </el-table-column>
          <el-table-column
            align="center"
            width="240"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="detailOpenBtn(scope.row.id)" type="text" size="small">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
    <!-- 拼团详情弹窗 -->
    <el-dialog
      title="拼团详情"
      :visible.sync="detailShow"
      width="960px">
      <el-table
        border
        :data="detailList">
        <el-table-column
          align="center"
          prop="headPicture"
          label="用户头像">
          <template slot-scope="scope">
            <el-image
              style="width: 40px;"
              :src="scope.row.headPicture == null ? imgServer+'no_img.png' : scope.row.headPicture"
              :preview-src-list="[scope.row.headPicture]"
              fit="contain"></el-image>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="nickName"
          label="用户昵称">
        </el-table-column>
        <el-table-column
          align="center"
          prop="phone"
          label="用户手机号">
        </el-table-column>
        <el-table-column
          align="center"
          prop="orderNo"
          label="订单编号">
        </el-table-column>
        <el-table-column
          align="center"
          prop="realPayMoney"
          label="支付金额">
        </el-table-column>
        <el-table-column
          align="center"
          prop="orderStatus"
          label="订单状态">
          <template slot-scope="scope">
            <span v-if="scope.row.orderStatus === 0">拼团进行中</span>
            <span v-else-if="scope.row.orderStatus === 1" class="mt-green">拼团成功</span>
            <span v-else class="mt-red">拼团失败</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { queryPinTuanOrderPageList, fetchPinTuanOrderListByParentId } from '@/api/groupBuy'
export default {
  name: 'GroupList',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      infoId: '',
      fullscreenLoading: false,
      searchForm: {
        name: '',
        orderStatus: '',
        date: ['', '']
      },
      orderStatusArr: [{
        label:'拼团进行中',
        value:0
      },{
        label:'拼团成功',
        value:1
      },{
        label:'拼团失败',
        value:2
      }],
      // 拼团详情弹窗
      detailShow:false,
      detailList:[]
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 拼团详情弹窗-打开弹窗操作
    detailOpenBtn(parentId){
      var that = this;
      fetchPinTuanOrderListByParentId({parentId:parentId}).then((res) => {
          if (res.errorCode === '0000') {
            var data = res.data;
            that.detailList = data;
            that.detailShow = true;
          }
          if (res.errorCode === '1001') {
            that.$message.error(res.msg)
          }
        })
    },
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let orderStatus = that.searchForm.orderStatus
      let startDate = ''
      let endDate = ''
      if (that.searchForm.date !== null) {
        startDate = that.searchForm.date[0]
        endDate = that.searchForm.date[1]
      }
      let page = that.currentPage
      queryPinTuanOrderPageList({ goodsName: searchName,orderStatus:orderStatus,startTime:startDate,endTime:endDate,pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/groupBuy/GroupList.vue